import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../components/common';
import { isSafeRedirectUrl } from '../utils/redirectSafety';

function safeNext(raw) {
  if (!raw) return null;
  if (!isSafeRedirectUrl(raw)) return null;
  return raw;
}

export default function Logout() {
  const { logout } = useAuth();
  const location = useLocation();
  const toast = useToast();
  const [message, setMessage] = useState('Logging out…');

  useEffect(() => {
    const run = async () => {
      const params = new URLSearchParams(location.search || '');
      const next = safeNext(params.get('next')) || '/login';

      try {
        await logout();
      } catch (e) {
        // ignore; logout() already best-effort clears local state
      }

      toast.info('Logged out. Redirecting…');
      setMessage('Logged out. Redirecting…');
      window.location.replace(next);
    };

    run();
  }, [logout, location.search]);

  return (
    <div className="loading-screen">
      {message}
    </div>
  );
}


